export const getChatAttachments = (attachments) => {
  let value = attachments;
  if (typeof value === "string") {
    value = value.trim();
    if (!value) return [];
    try {
      value = JSON.parse(value);
    } catch {
      // Older messages and webhook replies may store a filename or URL directly.
    }
  }

  const entries = Array.isArray(value) ? value : [value];
  return entries
    .filter((entry) => typeof entry === "string" && entry.trim())
    .map((entry) => entry.trim());
};
